import {Component} from "react";
import React from "react";
import {events} from "../../helpers/Events";

/**
 * React component the stepper in top of the form
 * This component only displays the stepper the logic
 * for switching pages is located in VacancyFormFooterComponent
 */
export class FormStepperComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { page: props.initialPage };

        events.on('SwitchFormPage', page => {
            this.setState({ page: page })
        });
    }

    render() {
        const {pages} = this.props;
        const currentPage = this.state.page;

        let steps = pages.map((title, index) => {
            return (
                <FormStepComponent key={index}
                   title={title}
                   current={currentPage}
                   page={index}/>
            );
        });

        return (
            <div className="c-form-stepper">
                {steps}
            </div>
        )
    }
}


/**
 * Individual from step
 */
export class FormStepComponent extends Component {
    render() {
        const {title, page, current} = this.props;

        let cssName = "c-form-stepper__step";
        if (page == current) cssName += " c-form-stepper__step--active";
        if (page < current) cssName += " c-form-stepper__step--completed";
        if (page > current) cssName += " c-form-stepper__step--pending";

        return (
            <div className={cssName}>
                <span className="c-form-stepper__label">{title}</span>
            </div>
        );
    }
}
